<script setup>

import Ticker from "@/components/App/ticker.vue";
import footerDefault from "@/components/App/footer/footer.vue";

const refreshPage = () => {
    window.location.reload();
}
</script>

<template>
    <div class="silver-background">
        <ticker :is-show-prop="false"></ticker>
        <div class="container page column-page">
            <div class="warn">
                <svg width="20" height="19" viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M8.03056 1.161C8.88656 -0.387 11.1116 -0.387 11.9676 1.161L19.7136 15.162C20.5436 16.662 19.4586 18.502 17.7446 18.502H2.25456C0.539559 18.502 -0.545441 16.662 0.284559 15.162L8.03056 1.161ZM10.9976 14.502C11.0018 14.3682 10.9791 14.2349 10.9308 14.1101C10.8826 13.9853 10.8097 13.8714 10.7165 13.7753C10.6234 13.6791 10.5119 13.6027 10.3886 13.5505C10.2654 13.4983 10.1329 13.4714 9.99906 13.4714C9.86521 13.4714 9.73272 13.4983 9.60947 13.5505C9.48622 13.6027 9.37471 13.6791 9.28157 13.7753C9.18844 13.8714 9.11557 13.9853 9.06729 14.1101C9.01902 14.2349 8.99633 14.3682 9.00056 14.502C9.00877 14.7613 9.11756 15.0073 9.30392 15.1879C9.49028 15.3684 9.73958 15.4694 9.99906 15.4694C10.2585 15.4694 10.5078 15.3684 10.6942 15.1879C10.8806 15.0073 10.9894 14.7613 10.9976 14.502ZM10.7386 6.649C10.7126 6.46066 10.6162 6.2892 10.4687 6.16927C10.3212 6.04935 10.1336 5.98992 9.94394 6.00301C9.75428 6.01609 9.57667 6.10071 9.44702 6.23975C9.31737 6.3788 9.24536 6.56189 9.24556 6.752L9.24956 11.253L9.25656 11.355C9.28247 11.5433 9.37894 11.7148 9.52645 11.8347C9.67397 11.9547 9.86152 12.0141 10.0512 12.001C10.2408 11.9879 10.4185 11.9033 10.5481 11.7642C10.6777 11.6252 10.7498 11.4421 10.7496 11.252L10.7456 6.75L10.7386 6.649Z" fill="#DC33DF"/>
                </svg>
                <div class="warn-text">
                    <p>Похоже, вы используете VPN.</p>
                    <p>Пожалуйста, отключите его и перезагрузите страницу</p>
                </div>
                <p class="action" @click="refreshPage">Обновить страницу</p>
<!--            <button class="btn" @click="refreshPage"><span>Обновить</span></button>-->
            </div>
        </div>
    </div>
    <footer-default></footer-default>
</template>

<style scoped lang="scss">
    @use '~@/assets/styles/vars' as *;

    .container.page.column-page {
        min-height: calc(100vh - 30px);
        justify-content: center;
    }

    .warn {
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 15px;
    }
    p {
        font-size: 20px;
        text-align: center;
    }

    .action {
        font-size: 18px;
        color: $purple;
        text-decoration: underline;
        cursor: pointer;

    }

    @media screen and (max-width: 750px) {
        .container.page.column-page {
            min-height: calc(100vh - 126px - 35px);
            justify-content: center;
        }
        .warn {
            margin-top: 30px;
        }
        p {
            font-size: 17px;
        }

        .action {
            font-size: 15px;
        }
    }
</style>